module.exports = __webpack_public_path__ + "img/chart-bar-vert-single.2d0c94e1.svg";